<template>
  <el-dialog
    :visible="isVisible"
    @close="hide"
    :title="title"
    :destroy-on-close="true"
  >
    <move-to-group-form
      :search-url="searchUrl"
      :store-url="moveUrl"
      :brand-id="brandId"
      @stored="onStored"
    ></move-to-group-form>
  </el-dialog>
</template>

<script>
import eventBus from "../../../event-bus";
import MoveToGroupForm from "../../../components/send-list/move-to-group-form";

export default {
  props: {
    searchUrl: String,
  },

  components: {
    MoveToGroupForm,
  },

  data() {
    return {
      isVisible: false,
      moveUrl: null,
      brandId: null,
    };
  },

  computed: {
    /**
     * @return {string}
     */
    title() {
      return "Move to another group";
    },
  },

  methods: {
    /**
     * @return {undefined}
     */
    hide() {
      this.isVisible = false;
      this.moveUrl = null;
      this.brandId = null;
    },

    /**
     * @param {string|undefined} message
     */
    onStored({message}) {
      _.isString(message) && this.$message.success(message);
      this.hide();
      eventBus.$emit('send-list-items-updated');
    },

    /**
     * @param {String} url
     * @param {Number} brand_id
     */
    show({url, brand_id}) {
      this.moveUrl = url;
      this.brandId = brand_id;
      this.isVisible = true;
    },
  },

  created() {
    eventBus.$on('show-move-to-group-dialog', this.show);
  },

  beforeDestroy() {
    eventBus.$off('show-move-to-group-dialog', this.show);
  },
}
</script>

<style scoped>

</style>
